import React, { createContext, useContext, useEffect, useState } from 'react';
const YOUTUBE_IFRAME_API_URL = 'https://www.youtube.com/iframe_api';

export type YouTubeIframeApiContextProps = {
  youTubeIframeApi?: any;
  isReady: boolean;
};

export const YouTubeIframeApiContext = createContext<YouTubeIframeApiContextProps>({
  isReady: false,
  youTubeIframeApi: undefined,
});

type YouTubeIframeApiProviderProps = {
  children: React.ReactElement;
};

export const YouTubeIframeApiProvider = ({ children }: YouTubeIframeApiProviderProps) => {
  const [isReady, setIsReady] = useState<boolean>(false);

  useEffect(() => {
    const loadYoutubeIframeApi = async () => {
      if (window.YT) {
        if (!isReady) setIsReady(true);
        return;
      }

      window.onYouTubeIframeAPIReady = () => setIsReady(true);

      const tag = document.createElement('script');
      tag.src = YOUTUBE_IFRAME_API_URL;

      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);
    };

    loadYoutubeIframeApi();
  }, []);

  return (
    <YouTubeIframeApiContext.Provider
      value={{
        isReady,
        youTubeIframeApi: window.YT,
      }}
    >
      {children}
    </YouTubeIframeApiContext.Provider>
  );
};

export const useYoutubeIframeApiContext = () => {
  const context = useContext(YouTubeIframeApiContext);
  if (context === undefined) {
    throw new Error('useYoutubeIframeApiContext must be used within a YouTubeIframeApiProvider');
  }
  return context;
};
